(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this.querySelector('.header-wrapper') || this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.setHeaderBounds();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    setHeaderBounds() {
      const headerWrapper = this.header.classList.contains('header-wrapper') ? this.header : this.querySelector('.header-wrapper');
      if (!headerWrapper) return;
      const rect = headerWrapper.getBoundingClientRect();
      const decorativeBorderHeight = headerWrapper.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      this.headerBounds = {
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height + decorativeBorderHeight,
      };
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      this.setHeaderBounds();
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.height) {
        if (this.headerIsAlwaysSticky) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.height) {
        if (this.headerIsAlwaysSticky) return;
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.height) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      const target = this.header.classList.contains('header-wrapper') ? this.header : this;
      target.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
    reveal() {
      const target = this.header.classList.contains('header-wrapper') ? this.header : this;
      target.classList.add('shopify-section-header-sticky', 'animate');
      target.classList.remove('shopify-section-header-hidden');
    }
    reset() {
       const target = this.header.classList.contains('header-wrapper') ? this.header : this;
       target.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
    const headerWrapper = document.querySelector('[data-main-header-wrapper]');
    const body = document.body;

    if (headerWrapper && headerWrapper.classList.contains('header-wrapper--transparent-on-index')) {
      const getAnnouncementBarHeight = () => {
        const announcementBar = document.querySelector('#shopify-section-announcement-bar .announcement-bar, #shopify-section-announcement-bar');
        if (announcementBar && announcementBar.offsetHeight > 0) {
          const barSection = announcementBar.closest('.shopify-section');
          const isBarVisible = window.getComputedStyle(announcementBar).display !== 'none' && window.getComputedStyle(announcementBar).visibility !== 'hidden';
          const isSectionVisible = barSection ? window.getComputedStyle(barSection).display !== 'none' && window.getComputedStyle(barSection).visibility !== 'hidden' : true;
          if (isBarVisible && isSectionVisible) {
            return announcementBar.offsetHeight;
          }
        }
        return 0;
      };

      const getTotalHeaderInitialHeight = () => {
        if (!headerWrapper) return 0;
        return headerWrapper.offsetHeight;
      };

      const adjustHeaderTopPosition = () => {
        if (!headerWrapper) return;
        const announcementBarHeight = getAnnouncementBarHeight();
        headerWrapper.style.top = `${announcementBarHeight}px`;
      };

      const setFirstSectionPadding = () => {
        if (!headerWrapper || !body.classList.contains('template-index')) return;

        const headerSectionElement = headerWrapper.closest('.shopify-section.section-header');
        let firstContentSection = null;
        if (headerSectionElement) {
          firstContentSection = headerSectionElement.nextElementSibling;
          while(firstContentSection &&
                (firstContentSection.matches('script, style, template') ||
                 firstContentSection.nodeType === Node.COMMENT_NODE ||
                 !firstContentSection.classList.contains('shopify-section'))) {
            firstContentSection = firstContentSection.nextElementSibling;
          }
        }

        if (firstContentSection) {
            requestAnimationFrame(() => {
                const finalAnnounceHeight = getAnnouncementBarHeight();
                const finalHeaderHeight = getTotalHeaderInitialHeight();
                const totalPadding = finalAnnounceHeight + finalHeaderHeight;
                console.log('Header JS - Announcement Bar Height:', finalAnnounceHeight);
                console.log('Header JS - Main Header Wrapper Height (sticky part):', finalHeaderHeight);
                console.log('Header JS - Total Calculated Padding-Top:', totalPadding);
                console.log('Header JS - Applying padding to:', firstContentSection);
                firstContentSection.style.paddingTop = totalPadding + 'px';
            });
        } else {
             console.warn('Header JS: Could not find the first content section to apply padding.');
        }
      };

      const scrollHandlerForMainHeader = () => {
        if (!headerWrapper) return;
        const announcementBarHeight = getAnnouncementBarHeight();
        let scrollThreshold = getTotalHeaderInitialHeight();
        if (scrollThreshold < 50) scrollThreshold = 50;

        if (window.pageYOffset > (scrollThreshold + announcementBarHeight)) {
          headerWrapper.classList.add('site-header--scrolled');
        } else {
          headerWrapper.classList.remove('site-header--scrolled');
        }
      };

      const runAllMainHeaderAdjustments = (isDelayedRun = false) => {
          if (!headerWrapper) return;
          adjustHeaderTopPosition();
          if (isDelayedRun) {
            setFirstSectionPadding();
          }
          scrollHandlerForMainHeader();
      };

      runAllMainHeaderAdjustments(false);
      setTimeout(() => runAllMainHeaderAdjustments(true), 300);

      window.addEventListener('scroll', scrollHandlerForMainHeader, { passive: true });
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => runAllMainHeaderAdjustments(true), 300);
      }, { passive: true });

      const reapplyMainHeaderAdjustmentsWithPadding = () => setTimeout(() => runAllMainHeaderAdjustments(true), 500);

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.id === 'shopify-section-announcement-bar' || event.target.closest('[data-main-header-wrapper]')) {
            reapplyMainHeaderAdjustmentsWithPadding();
        }
      });
      document.addEventListener('shopify:section:unload', (event) => {
         if (event.target.id === 'shopify-section-announcement-bar' || event.target.closest('[data-main-header-wrapper]')) {
            reapplyMainHeaderAdjustmentsWithPadding();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
